import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import 'react-select/dist/react-select.css';
import 'react-quill/dist/quill.snow.css';
import './assets/stylesheets/editor.css';
import './assets/stylesheets/grading-matrix.css';
import reducers from './reducers';
import App from './components/App';
import { LOG_IN_USER, LOG_OUT_USER, registerLogoutDispatch } from './actions/authenticationActions';
import Tenant from './components/utils/Tenant';
import { tenant_in_state } from './actions/tenantActions';
import { setupAuthChannel } from './components/utils/authChannel';

const extension = (window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f);
const store = createStore(
  reducers,
  compose(applyMiddleware(thunk), extension)
);

// expose store when run in Cypress
if (window.Cypress) {
  window.store = store
}

// Registrar el dispatch para poder cerrar sesión por expiración
registerLogoutDispatch(store.dispatch);

// Función para crear el objeto usuario desde sessionStorage
const createUserFromSessionStorage = () => {
  const authenticationToken = sessionStorage.getItem('authenticationToken');
  if (authenticationToken) {
    return {
      authenticationToken: authenticationToken,
      email: sessionStorage.getItem('email'),
      name: sessionStorage.getItem('name'),
      isStudent: sessionStorage.getItem('isStudent'),
      isGrader: sessionStorage.getItem('isGrader'),
      isReviewer: sessionStorage.getItem('isReviewer'),
      isAdmin: sessionStorage.getItem('isAdmin'),
      isExamAdmin: sessionStorage.getItem('isExamAdmin'),
      isTeacher: sessionStorage.getItem('isTeacher'),
    };
  }
  return null;
};
store.dispatch(tenant_in_state()) //setea el tenant en el state antes que se renderie la app

const renderApp = () => {
  ReactDOM.render(
    <Provider store={store}>
      <>
      <Tenant/>
      <App />  
      </>
    </Provider>,  
    document.getElementById('root')
  );
};

// Configuracion BroadcastChannel para compartir tokens entre pestañas
setupAuthChannel(
  ({ token: receivedToken, userData }) => {
    const user = {
      authenticationToken: receivedToken,
      ...userData
    };
    store.dispatch({
      type: LOG_IN_USER,
      payload: user
    });
  },
  () => {
    // Callback que se ejecuta cuando el canal está listo
    renderApp();
  },
  () => {
    store.dispatch({ type: LOG_OUT_USER });
    window.location.reload();
  }
);

// si ya hay un token en sessionStorage, lo setea en el state
const user = createUserFromSessionStorage();
if (user) { 
  store.dispatch({
    type: LOG_IN_USER,
    payload: user
  });
}